import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import APProgressBar, {
  ProgressBarColorOption,
} from "../../components/APProgressBar";
import { CRMAppLocationIdentifier, FaqProps } from "../../types/Faq";

const VEHICLE_STAT_COLORS: ProgressBarColorOption[] = [
  "error",
  "error",
  "error",
  "primary",
  "primary",
  "primary",
  "primary",
  "tertiaryGreen",
  "tertiaryGreen",
  "tertiaryGreen",
];

type StatDetails = {
  value: string;
  comfort: string;
  performance: string;
  costToRun: string;
};

type StatFaqs = {
  value?: CRMAppLocationIdentifier;
  comfort?: CRMAppLocationIdentifier;
  performance?: CRMAppLocationIdentifier;
  costToRun?: CRMAppLocationIdentifier;
};

const VehicleStats = ({
  value,
  comfort,
  performance,
  costToRun,
  statDetails,
  disclaimer,
  forceOpen,
  forceClose,
  grid = false,
  faqProps,
  faqs,
}: {
  value: number;
  comfort: number;
  performance: number;
  costToRun?: number;
  statDetails?: StatDetails;
  disclaimer?: string;
  forceOpen?: boolean;
  forceClose?: boolean;
  grid?: boolean;
  faqProps?: FaqProps;
  faqs?: StatFaqs;
}) => {
  const renderProgressBar = (
    title: string,
    value: number,
    expandText?: string,
    faqAppLocationIdentifier?: CRMAppLocationIdentifier
  ) => {
    const renderAppLocation = faqProps?.renderAppLocation;
    const renderedBar = (
      <APProgressBar
        title={title}
        value={value}
        maxValue={10}
        colorSpectrum={VEHICLE_STAT_COLORS}
        largeTitle={!!statDetails}
        expandText={expandText}
        forceOpen={forceOpen}
        forceClose={forceClose}
        hideExpandToggle={true}
      />
    );
    return renderAppLocation && faqAppLocationIdentifier
      ? renderAppLocation(faqAppLocationIdentifier, renderedBar)
      : renderedBar;
  };

  return (
    <Box>
      <Stack
        sx={{
          display: grid ? "grid" : "flex",
          gridTemplateColumns: grid ? { md: "1fr 1fr" } : "auto",
          columnGap: grid ? 2 : 0,
          rowGap: grid ? 1 : 0,
        }}
      >
        {renderProgressBar("Value", value, statDetails?.value, faqs?.value)}
        {renderProgressBar(
          "Comfort",
          comfort,
          statDetails?.comfort,
          faqs?.comfort
        )}
        {renderProgressBar(
          "Performance",
          performance,
          statDetails?.performance,
          faqs?.performance
        )}
        {costToRun &&
          renderProgressBar(
            "Running Cost",
            costToRun,
            statDetails?.costToRun,
            faqs?.costToRun
          )}
      </Stack>
      {disclaimer && (
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <Typography variant="labelSmall">{disclaimer}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default VehicleStats;
